import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminBookingsPageComponent } from './admin-bookings.page';

const routes: Routes = [
  {
    path: '',
    component: AdminBookingsPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminBookingsPageRoutingModule {}
